<template>
  <div
    class="relative"
    :class="{ 'border-l': vertical, 'border-t': !vertical }"
  >
    <div
      v-if="$slots.default"
      class="absolute left-1/2 -translate-y-1/2 -translate-x-1/2"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  vertical?: boolean;
}>();
</script>
